// extracted by mini-css-extract-plugin
export default {"buttonDashboards":"Dashboards_buttonDashboards__WgKXN","iconDash":"Dashboards_iconDash__691Ro","containerBtnDash":"Dashboards_containerBtnDash__yQ8w1"};